/* RB Home — design system behaviour (v4).
   Vanilla, deferred, idempotent. Every feature degrades to plain HTML:
   hero panels are links, add buttons are form posts, the stepper is a number
   input, variant options are radios inside the product form. */
(function () {
  'use strict';

  var strings = window.rbhStrings || {};

  function live(msg) {
    var el = document.getElementById('rbh-live');
    if (!el) return;
    el.textContent = '';
    window.setTimeout(function () { el.textContent = msg; }, 50);
  }

  /* ── Room hero: four panels, the hovered/focused one expands ──────────── */
  function initHero(root) {
    if (root.dataset.rbhReady) return;
    root.dataset.rbhReady = '1';
    var panels = Array.prototype.slice.call(root.querySelectorAll('.rbh-hero__panel'));
    var wide = window.matchMedia('(min-width: 901px)');
    function setActive(panel) {
      panels.forEach(function (p) { p.dataset.active = p === panel ? 'true' : 'false'; });
      root.classList.toggle('rbh-hero--engaged', !!panel && wide.matches);
    }
    panels.forEach(function (p) {
      p.addEventListener('mouseenter', function () { if (wide.matches) setActive(p); });
      p.addEventListener('focus', function () { setActive(p); });
    });
    root.addEventListener('mouseleave', function () { setActive(null); });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) setActive(null);
    });
  }

  /* ── Header basket count ──────────────────────────────────────────────── */
  function refreshCount() {
    return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-rbh-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.querySelectorAll('[data-rbh-cart-label]').forEach(function (el) {
          el.setAttribute('aria-label', (strings.basket || 'Basket') + (cart.item_count ? ' (' + cart.item_count + ')' : ''));
        });
        return cart;
      });
  }

  /* ── Add to basket, confirmed in place ────────────────────────────────── */
  function initAddForm(form) {
    if (form.dataset.rbhReady) return;
    form.dataset.rbhReady = '1';
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return; // plain post
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var msg = form.querySelector('[data-rbh-msg]');
      if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      if (msg) msg.textContent = '';
      var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || strings.addError || 'Error');
          btn.dataset.added = 'true';
          swapLabels(btn, true);
          live(strings.added || 'Added to basket');
          window.clearTimeout(btn._rbhTimer);
          btn._rbhTimer = window.setTimeout(function () {
            btn.dataset.added = 'false';
            swapLabels(btn, false);
          }, 1600);
          return refreshCount();
        })
        .catch(function (err) {
          if (msg) msg.textContent = err.message;
          live(err.message);
        })
        .finally(function () { btn.removeAttribute('aria-busy'); });
    });
  }
  function swapLabels(btn, added) {
    var states = btn.querySelectorAll('.rbh-add__state, [data-rbh-state]');
    states.forEach(function (s) {
      var isAdded = s.hasAttribute('data-rbh-added');
      var on = added ? isAdded : !isAdded;
      s.dataset.on = on ? 'true' : 'false';
      s.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
  }

  /* ── Quantity stepper ─────────────────────────────────────────────────── */
  function initStepper(root) {
    if (root.dataset.rbhReady) return;
    root.dataset.rbhReady = '1';
    var input = root.querySelector('input');
    var dec = root.querySelector('[data-rbh-step="-1"]');
    var inc = root.querySelector('[data-rbh-step="1"]');
    function bounds() {
      return { min: parseInt(input.min || '1', 10), max: parseInt(input.max || '99', 10) };
    }
    function sync() {
      var b = bounds();
      var v = parseInt(input.value, 10) || b.min;
      if (dec) dec.disabled = v <= b.min;
      if (inc) inc.disabled = v >= b.max;
    }
    function step(d) {
      var b = bounds();
      var v = Math.min(b.max, Math.max(b.min, (parseInt(input.value, 10) || b.min) + d));
      if (String(v) === input.value) return;
      input.value = v;
      sync();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (dec) dec.addEventListener('click', function () { step(-1); });
    if (inc) inc.addEventListener('click', function () { step(1); });
    input.addEventListener('input', sync);
    sync();
  }

  /* ── Cart: quantity changes submit the cart form ──────────────────────── */
  function initCart(form) {
    if (form.dataset.rbhReady) return;
    form.dataset.rbhReady = '1';
    var timer;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="updates[]"]')) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        form.classList.add('rbh-cart__updating');
        form.submit();
      }, 450);
    });
  }

  /* ── Product: gallery thumbnails ──────────────────────────────────────── */
  function initGallery(root) {
    if (root.dataset.rbhReady) return;
    root.dataset.rbhReady = '1';
    var main = root.querySelector('[data-rbh-main]');
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-rbh-thumb]');
      if (!t || !main) return;
      showMedia(root, t.dataset.mediaId);
    });
  }
  function showMedia(gallery, mediaId) {
    var main = gallery.querySelector('[data-rbh-main]');
    var t = gallery.querySelector('[data-rbh-thumb][data-media-id="' + mediaId + '"]');
    if (!main || !t) return;
    var img = main.querySelector('img');
    if (img) {
      img.src = t.dataset.src;
      img.srcset = t.dataset.srcset || '';
      img.alt = t.dataset.alt || '';
    }
    gallery.querySelectorAll('[data-rbh-thumb]').forEach(function (b) {
      b.setAttribute('aria-current', b === t ? 'true' : 'false');
    });
  }

  /* ── Product: variant options ─────────────────────────────────────────── */
  function initProduct(root) {
    if (root.dataset.rbhReady) return;
    root.dataset.rbhReady = '1';
    var json = root.querySelector('[data-rbh-variants]');
    if (!json) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    var form = root.querySelector('form[data-rbh-add-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var btn = form && form.querySelector('[type="submit"]');
    var priceEl = root.querySelector('[data-rbh-price]');
    var gallery = root.querySelector('[data-rbh-gallery]');
    var money = root.dataset.moneyFormat || '€{{amount_with_comma_separator}}';

    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-rbh-option]')) return;
      var chosen = Array.prototype.map.call(
        root.querySelectorAll('fieldset[data-rbh-position]'),
        function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        }
      );
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === chosen[i]; });
      });
      update(v);
    });

    function update(v) {
      if (!idInput || !btn) return;
      var label = btn.querySelector('[data-rbh-btn-label]') || btn;
      if (!v) {
        btn.disabled = true;
        label.textContent = strings.unavailable || 'Unavailable';
        return;
      }
      idInput.value = v.id;
      btn.disabled = !v.available;
      label.textContent = v.available ? (strings.addToBasket || 'Add to basket') : (strings.soldOut || 'Sold out');
      if (priceEl) priceEl.innerHTML = priceHtml(v);
      if (v.featured_media && gallery) showMedia(gallery, String(v.featured_media.id));
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function fmt(cents) {
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
      return money
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0])
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
        .replace(/\{\{\s*amount\s*\}\}/, withDot);
    }
    function priceHtml(v) {
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      return '<span class="rbh-price rbh-price--lg' + (sale ? ' rbh-price--onSale' : '') + '">' +
        '<span class="rbh-price__now">' + fmt(v.price) + '</span>' +
        (sale ? '<s class="rbh-price__was">' + fmt(v.compare_at_price) + '</s>' : '') +
        '<span class="rbh-price__vat">' + (strings.inclVat || 'incl. VAT') + '</span></span>';
    }
  }

  /* ── Boot ─────────────────────────────────────────────────────────────── */
  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-rbh-hero]').forEach(initHero);
    scope.querySelectorAll('form[data-rbh-add-form]').forEach(initAddForm);
    scope.querySelectorAll('[data-rbh-stepper]').forEach(initStepper);
    scope.querySelectorAll('form[data-rbh-cart]').forEach(initCart);
    scope.querySelectorAll('[data-rbh-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-rbh-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
